import { extendObservable } from "mobx";
import { ISubshiftEntity, SubshiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { ShiftEditorViewStateSchema } from "..";

export default mutatorAction("updateActivityInOpenShift", function updateActivityInOpenShift(
    store: ShiftEditorViewStateSchema,
    updatedActivity: ISubshiftEntity
) {
    if (store && store.openShift && store.openShift.subshifts && updatedActivity) {
        const index: number = store.openShift.subshifts.findIndex((subshift: ISubshiftEntity) => subshift.id === updatedActivity.id);
        if (index > -1) {
            // extendObservable (target, props) copies all props value pairs onto target and marks them as observable.
            // In this panel we need the ActivityFlexContainer to react to changes to the subshifts, so we mark every property of the subshifts as observable
            store.openShift.subshifts.splice(index, 1, extendObservable(SubshiftEntity.clone(updatedActivity), {...updatedActivity}));
        }
    }
});